import * as _ from "lodash";
import * as moment from "moment";
export class DataFocusModalComponent implements ng.IComponentOptions {
  public controller: any = DataFocusModalController;
  public bindings: any = {
    modalInstance: "<",
    resolve: "<"
  }
  public template: string =
   `<div class="modal-header">
     <button type="button" class="close" ng-click="$ctrl.cancel()" aria-label="Close"><span aria-hidden="true">&times;</span></button>
     <h4 class="modal-title" id="datasetModal">View Row Data</h4>
   </div>
   <div class="modal-body">
    <table class="table table-hover table-striped">
      <tr ng-repeat="(key, data) in $ctrl.records">
        <td>{{key}}</td>
        <td>{{data}}</td>
      </tr>
    </table>
   </div>
   <div class="modal-footer">
     <button type="button" class="btn btn-default" ng-click="$ctrl.cancel()">Close</button>
   </div>
   <div class="overlay-loading" ng-show="$ctrl.submitting"></div>
   `;
}

export class DataFocusModalController {
  public static $inject: Array<string> = ["$timeout"];
  public modalInstance: ng.ui.bootstrap.IModalServiceInstance;
  public resolve: any;
  public records: any;
  constructor (private $timeout: ng.ITimeoutService) {
    $timeout(() => {
      if (this.resolve.records) {
        this.records = this.resolve.records;
        console.log(this.records)

      }
    })
  }

  public cancel() {
    this.modalInstance.dismiss("canceled");
  }

}
